exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.job-summary[data-v-3e32201d] {\n  padding: 0 24px;\n}\n.job-summary .input-field-label[data-v-3e32201d] {\n    padding-top: 14px;\n}\n.job-summary .input-field[data-v-3e32201d] {\n    margin: 0;\n}\n.job-summary .input-field input[data-v-3e32201d] {\n      margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3e32201d","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/sass-resources-loader/lib/loader.js?{"resources":"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss"}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/JobSummary.vue
// module id = 419
// module chunks = 1